import { Box, Alert, Link, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useState, useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { PRIMARY_BUTTON } from 'themes/theme'
import Button from 'components/Common/Button'
import iconAppStore from 'assets/mobile/app_store.png'
import iconPlayStore from 'assets/mobile/play_store.png'
import OtpTextBox from './OtpTextbox'
import api from 'api'
import { AuthStateContext } from 'context/auth'
import { fetchToken } from 'store/actions/authActions'
import moment from 'moment'
import { getOperatingSystem } from 'utils/helper'

const AccountVerificationMob = () => {
  const isMac = getOperatingSystem(window)?.toLowerCase()?.includes('mac')
  const isEpsg = useSelector(state => state.authReducer.EpsgUser)
  const dispatch = useDispatch()
  const emailInfo = useSelector(state => state.authReducer)
  const [otpCode, setOTP] = useState()
  const [spinner, setSpinner] = useState(false)
  const [inValid, setInvalid] = useState(false)
  const [showError, setShowError] = useState(false)
  const [otpSent, setOtpSent] = useState(false)
  const [limitError, setLimitError] = useState(false)
  const navigate = useNavigate()
  const [authState, authDispatch] = useContext(AuthStateContext)
  const { email, password, firstName, lastName } = authState
  setTimeout(() => {
    setOtpSent(null)
    setShowError(null)
    setLimitError(null)
  }, 3500)
  const handleSubmit = e => {
    setSpinner(true)
    e.preventDefault()
    if (email && password) {
      api
        .confirmSignUpEmail(email.toLowerCase(), otpCode)
        .then(async res => {
          if (email && password) {
            try {
              let awsUser = await api.signIn(email.toLowerCase(), password)

              if (!firstName || !lastName) {
                const _firstName = awsUser.attributes['custom:firstName']
                const _lastName = awsUser.attributes['custom:lastName']
                isEpsg &&
                  fetchToken({
                    email,
                    password,
                    ep: isEpsg,
                    firstName: _firstName,
                    lastName: _lastName,
                  })

                const createUserRes = await api.createUser({
                  firstName: _firstName,
                  lastName: _lastName,
                  accountType: isEpsg ? 'premium' : 'free',
                })
                await api.createBusinessDefault({
                  business_name: `${_firstName}_${_lastName}_${moment().unix()}`,
                  cognito_user_id: createUserRes['id'] || '',
                  ep: isEpsg ? isEpsg : null,
                })
              } else {
                isEpsg &&
                  fetchToken({
                    email,
                    password,
                    ep: isEpsg,
                    firstName: firstName,
                    lastName: lastName,
                  })

                const createUserRes = await api.createUser({
                  firstName,
                  lastName,
                  accountType: isEpsg ? 'premium' : 'free',
                })

                await api.createBusinessDefault({
                  business_name: `${firstName}_${lastName}_${moment().unix()}`,
                  cognito_user_id: createUserRes['id'] || '',
                  ep: isEpsg ? isEpsg : null,
                })
              }

              const user = await api.getUser()
              user.defaultBusinessCreated = true
              dispatch({ type: 'userUpdated', user })
              authDispatch({ type: 'signUpCompleted' })
              navigate('/auth/mobile/verified')
            } catch (error) {
              console.log('Confirm error: ', error)
            }
          }
        })
        .catch(error => {
          if (error.name === 'CodeMismatchException') {
            setShowError('Incorrect code. Please try again.')
          } else if (error.name === 'LimitExceededException') {
            setLimitError(true)
          } else {
            setShowError(error.message)
          }
        })
        .finally(() => {
          setSpinner(false)
        })
    }
  }
  const handleBlur = e => {
    const { value } = e.target
    if (!value) {
      setInvalid('This field is Required')
    } else {
      setInvalid(false)
    }
  }
  const handleResend = () => {
    api
      .resendSignUp(email.toLowerCase())
      .then(res => {
        if (res) {
          setOtpSent(true)
        }
      })
      .catch(error => {
        if (error.name === 'LimitExceededException') {
          setLimitError(true)
        } else {
          setShowError(error.message)
        }
      })
  }
  return (
    <Box
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      display="flex"
      color="#66668F"
      marginTop="46px"
      textAlign="center"
    >
      <Box onSubmit={handleSubmit} component="form">
        <Typography variant="h6" margin="40px 0px 10px 0px" color="#25245f">
          Lastly, verification
        </Typography>
        <Typography variant="body2" padding="0px 25px">
          Enter the verification code sent to your business email
        </Typography>
        <Box className={`my-3 authForm ${inValid ? 'inValid' : ''}`} margin="40px 0px" padding="25px">
          <OtpTextBox
            length={6}
            name="code"
            onBlur={handleBlur}
            onComplete={e => {
              setOTP(e)
            }}
          />
        </Box>
        <Box className="mt-5" textAlign="center">
          <Button
            // disabled={!otpCode}
            type={PRIMARY_BUTTON}
            sx={{ width: '250px', height: '50px', marginBottom: '15px' }}
            submit
            loading={spinner}
          >
            Submit
          </Button>
        </Box>
        <Link
          onClick={handleResend}
          sx={{ cursor: 'pointer', textDecoration: 'underline', textDecorationColor: '#0A78CD' }}
        >
          <Typography component="span" variant="button3" color="secondary">
            Resend code
          </Typography>
        </Link>
        {otpSent && emailInfo?.email && (
          <Box padding="25px">
            <Alert role="alert" onClose={() => setOtpSent(false)} severity="success">
              A code has been resent to <b>{emailInfo?.email}</b>
            </Alert>
          </Box>
        )}
        {limitError && (
          <Box padding="20px">
            <Alert role="alert" severity="error" className="mt-2" onClose={() => setLimitError(false)}>
              Too many attempts. Please contact{' '}
              <Link
                href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z"
                rel="noreferrer"
                target="_blank"
                fontWeight="bold"
                color="#D14343 !important"
                textDecoration="underline"
                sx={{ textDecorationColor: '#D14343 !important' }}
              >
                Customer Support
              </Link>{' '}
              for help.
            </Alert>
          </Box>
        )}
        {showError && (
          <Box padding="20px">
            <Alert role="alert" severity="error" className="mt-2" onClose={() => setShowError(false)}>
              {showError}
            </Alert>
          </Box>
        )}
        <Box margin="40px 0px">
          <Typography variant="caption">
            Already have an account?
            <br />
            Please go to your desktop or app to sign in.
          </Typography>
        </Box>
        <Box>
          <img
            style={{ cursor: 'pointer' }}
            src={isMac ? iconAppStore : iconPlayStore}
            width={150}
            alt="mobilestore"
            onClick={() => {
              if (isMac) {
                window.open('https://apps.apple.com/us/app/markaaz/id1632920268', '_self')
              } else {
                window.open('https://play.google.com/store/apps/details?id=com.markaaz.dashboard&hl=en&gl=US')
              }
            }}
          />
        </Box>
      </Box>
      <Box margin="40px">
        <Typography variant="caption">
          By creating an account, I acknowledge I have read, understand, and agree to the Markaaz’s&nbsp;
          <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/terms-and-conditions" target="_blank">
            Terms and Conditions
          </a>
          , including the arbitration, limitation of liability, and class waiver provisions. I also confirm I have read
          and understand the Markaaz &nbsp;
          <a rel="noreferrer" className="authLinkMob" href="https://markaaz.com/privacy/" target="_blank">
            Privacy Policy
          </a>
          .
        </Typography>
      </Box>
    </Box>
  )
}

export default AccountVerificationMob
